import { UnitCertificateSectionValues } from '@constants/common';
import { SoaDocumentsReducerStateType } from '@modules/unit-certificate/unit-certificates-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  order: 'desc',
  sortBy: 'date_of_upload',
  totalCount: 0,
  soaDocumentDetails: {},
  section: UnitCertificateSectionValues.UPLOAD,
  disableUpload: false
} as SoaDocumentsReducerStateType;

export const SoaDocumentsStateReducerSlice = createSlice({
  name: 'soaDocumentsStateReducer',
  initialState,
  reducers: {
    resetSoaDocumentsStateReducerValues: () => initialState,
    updateSoaDocumentsStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const {
  resetSoaDocumentsStateReducerValues,
  updateSoaDocumentsStateReducerValues
} = SoaDocumentsStateReducerSlice.actions;

export default SoaDocumentsStateReducerSlice.reducer;
